/* eslint @typescript-eslint/naming-convention: 0 */

import { generateHashedString } from '@/utils/generateHashedString';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import { captureException } from '@/wabunka-src/common/utils/sentry';
import type { CONTACT_US_TOPIC } from '@/wabunka-src/constants/contactUs';

type ContactUsTopic = (typeof CONTACT_US_TOPIC)[number];

export interface ContactUsParams {
  topic: ContactUsTopic;
  user_id?: string;
}

const buildContactUsParams = (topic: ContactUsTopic, user_id?: string): ContactUsParams => {
  return {
    topic,
    ...(user_id && { user_id }),
  };
};

export const sendGAWabunkaContactUsEvent = async (topic: ContactUsTopic, email?: string) => {
  // Guard against missing email and compute hash
  let hashedEmail: string | undefined;
  if (email) {
    try {
      // Match Meta conversion hashing: lowercase then SHA-256
      hashedEmail = await generateHashedString(email.toLowerCase());
    } catch (error) {
      const newError = new Error('Failed to hash email for GA event: ' + (error as Error).message);
      captureException(newError);
    }
  }

  sendWabunkaGAEvent('contact_us', buildContactUsParams(topic, hashedEmail));
};
